import TokensService from '@omni/kit/services/TokensService';

import BaseService, { IHttpResponse } from '../../../BaseService';
import { IPrepareTranslationUrl, prepareTranslationUrl } from '../BuildUrls';
import Cache from '../Cache';
import { ITranslation } from '../Types';

const debug = require('debug')('tca:service:TranslationService:Core:GetAll');

interface ITranslationGetAll extends Omit<IPrepareTranslationUrl, 'id'> {
  getFromCache?: boolean;
  appKey?: string;
}

interface ITranslationsGetAllResponse extends IHttpResponse {
  body?: {
    _embedded: {
      translations: ITranslation[];
    };
  };
}

export default async ({
  getFromCache,
  appKey,
  ...buildUrlProps
}: ITranslationGetAll): Promise<ITranslationsGetAllResponse> => {
  debug('GetAll');
  const url = prepareTranslationUrl(buildUrlProps);

  const guestToken = await TokensService.getGuestToken();

  return BaseService.Get({
    url,
    appKey,
    getFromCache,
    token: guestToken,
    cache: Cache,
  });
};
